<!-- Ticket Details Tab -->
<div class="ticket-details-tab">

  <!-- Details Grid -->
  <div class="details-grid">

    <!-- Status -->
    @if (status) {
      <div class="detail-item">
        <div class="detail-label">Status</div>
        <div class="detail-value">
          <app-status-pill
            variant="solid"
            [color]="getStatusColor()"
            [label]="status"
            [truncateAt]="30">
          </app-status-pill>
        </div>
      </div>
    }

    <!-- Priority -->
    @if (priority) {
      <div class="detail-item">
        <div class="detail-label">Priority</div>
        <div class="detail-value">{{ priority }}</div>
      </div>
    }

    <!-- Due Date -->
    @if (dueDate) {
      <div class="detail-item">
        <div class="detail-label">Due Date</div>
        <div class="detail-value">{{ dueDate | date: 'mediumDate' }}</div>
      </div>
    }

    <!-- Start Date (Time Planning: "Start Task On") -->
    @if (startDate) {
      <div class="detail-item">
        <div class="detail-label">Start Date</div>
        <div class="detail-value">{{ startDate | date: 'mediumDate' }}</div>
      </div>
    }

    <!-- End Date (Time Planning: "Finish") -->
    @if (endDate) {
      <div class="detail-item">
        <div class="detail-label">End Date</div>
        <div class="detail-value">{{ endDate | date: 'mediumDate' }}</div>
      </div>
    }

    <!-- Stage -->
    @if (stage) {
      <div class="detail-item">
        <div class="detail-label">Stage</div>
        <div class="detail-value">{{ stage }}</div>
      </div>
    }

    <!-- Ticket Type -->
    @if (ticketType) {
      <div class="detail-item">
        <div class="detail-label">Ticket Type</div>
        <div class="detail-value">{{ ticketType }}</div>
      </div>
    }

    <!-- Scopes -->
    @if (scopes && scopes.length > 0) {
      <div class="detail-item">
        <div class="detail-label">Scopes</div>
        <div class="detail-value">
          <div class="scope-chips">
            @for (scope of scopes; track scope) {
              <span class="scope-chip" [ngStyle]="getScopeChipStyles(scope)" [title]="scope.name">
                <span class="scope-chip-label">{{ scope.name }}</span>
              </span>
            }
          </div>
        </div>
      </div>
    }

    <!-- Customer -->
    @if (customer) {
      <div class="detail-item">
        <div class="detail-label">Customer</div>
        <div class="detail-value">{{ customer }}</div>
      </div>
    }

    <!-- Vendor -->
    @if (vendor) {
      <div class="detail-item">
        <div class="detail-label">Vendor</div>
        <div class="detail-value">{{ vendor }}</div>
      </div>
    }

    <!-- Subcontractor -->
    @if (subcontractor) {
      <div class="detail-item">
        <div class="detail-label">Subcontractor</div>
        <div class="detail-value">{{ subcontractor }}</div>
      </div>
    }

    <!-- Responsible Party -->
    @if (responsibleParty) {
      <div class="detail-item">
        <div class="detail-label">Responsible Party</div>
        <div class="detail-value">{{ responsibleParty }}</div>
      </div>
    }

    <!-- Assignee (Created By) -->
    @if (assignee) {
      <div class="detail-item">
        <div class="detail-label">Assignee</div>
        <div class="detail-value">{{ assignee }}</div>
      </div>
    }

    <!-- Created Date -->
    @if (createdDate) {
      <div class="detail-item">
        <div class="detail-label">Created On</div>
        <div class="detail-value">{{ createdDate | date: 'medium' }}</div>
      </div>
    }

    <!-- Legacy support for ticketData object -->
    @if (ticketData && !status) {
      <!-- Module -->
      @if (ticketData?.module) {
        <div class="detail-item">
          <div class="detail-label">Module</div>
          <div class="detail-value">{{ ticketData.module?.name }}</div>
        </div>
      }
      <!-- Reference -->
      @if (ticketData?.reference) {
        <div class="detail-item">
          <div class="detail-label">Reference</div>
          <div class="detail-value">{{ ticketData.reference?.name }}</div>
        </div>
      }
      <!-- Updated On -->
      @if (ticketData?.updated_at) {
        <div class="detail-item">
          <div class="detail-label">Last Updated</div>
          <div class="detail-value">{{ ticketData.updated_at | date: 'medium' }}</div>
        </div>
      }
    }

  </div>

</div>
